/**
 * L'edizione su cui si sta lavorando: sta in localStorage perche' sopravvive al ricarico della
 * pagina, e sidebar e pagine del torneo la leggono da li'.
 *
 * La chiave e l'evento che avvisa chi la sta guardando stanno solo qui: chi la cambia senza
 * avvisare lascia il menu del torneo acceso su un'edizione che le pagine non vedono piu'.
 */
const CHIAVE = 'selectedEdition';
const EVENTO = 'editionSelected';

const avvisa = (edizione) => {
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: { edition: edizione } }));
};

const EdizioneService = {
  evento: EVENTO,

  /** L'edizione scelta, o null se non c'e' (anche quando quello che c'e' scritto e' illeggibile). */
  get: () => {
    const salvata = localStorage.getItem(CHIAVE);
    if (!salvata) return null;

    try {
      return JSON.parse(salvata);
    } catch (errore) {
      console.error('Edizione selezionata illeggibile, la butto', errore);
      localStorage.removeItem(CHIAVE);
      return null;
    }
  },

  set: (edizione) => {
    localStorage.setItem(CHIAVE, JSON.stringify(edizione));
    avvisa(edizione);
  },

  clear: () => {
    localStorage.removeItem(CHIAVE);
    avvisa(null);
  }
};

export default EdizioneService;
